import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Button,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Box,
  useToast,
} from "@chakra-ui/react";
import * as React from "react";
import { esgAdminKeys, useCreateOrg, useUpdateOrgModules } from "../../hooks/query/esg-admin/esg-admin";
import { hideAppSpinner, showAppSpinner } from "../../context/Store/slices/appSpinnerSlice";
import { showErrorToast, showSuccessToast } from "../../utils";
import { useDispatch } from "react-redux";
import { useQueryClient } from "react-query";

/**
 Enforce Auth0 rules as you type
 * @param {string} name 
 * @returns {string}
 */
function auth0name(name) {
	if ( ! name) return "";
	return name.replace(/ /g, "-").toLowerCase();
}

const CreateOrgPopup = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const toast = useToast();
  const queryClient = useQueryClient();
  const [name, setName] = React.useState("");
  const [displayName, setDisplayName] = React.useState("");

  const { mutate: createOrg } = useCreateOrg({
    onMutate: () => dispatch(showAppSpinner()),
    onSuccess: () => {
      showSuccessToast(toast, "Organization created successfully.");
      queryClient.invalidateQueries(esgAdminKeys.orgs());
      onClose();
    },
    onError: (err) => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    onSettled: () => dispatch(hideAppSpinner()),
  });

  const handleSave = () => {
    const dataToSubmit = {
      name: name,
      displayName: displayName,
    };
    createOrg(dataToSubmit);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent bg="pureWhite">
        <ModalHeader>Create New Organization</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <Box mb={4}>
            <Stack spacing={4}>
              <FormControl isRequired>
                <FormLabel>Name</FormLabel>
                <Input placeholder="e.g. test-org-1" value={name} 
					onChange={(e) => setName(auth0name(e.target.value))} />
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Display Name</FormLabel>
                <Input
                  placeholder="Enter display name"
                  value={displayName}
                  onChange={(e) => setDisplayName(e.target.value)}
                />
              </FormControl>

              <Button onClick={() => handleSave()} variant="primary" type="submit">
                Submit
              </Button>
            </Stack>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default CreateOrgPopup;
